import { render, staticRenderFns } from "./TiposView.vue?vue&type=template&id=c659b72a&"
import script from "./TiposView.vue?vue&type=script&lang=js&"
export * from "./TiposView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports